/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { ModbusVariableAddress } from './models';
import { VariableType } from './models';
import { VariableMeta } from './models';
import { ReadWriteRights } from '@iotize/tap/service/impl/bundle';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

export class ModbusVariableAddressConverter
  implements BodyConverter<ModbusVariableAddress>
{
  public encode(
    model: ModbusVariableAddress,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeModbusVariableAddress(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): ModbusVariableAddress {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readModbusVariableAddress();
  }
}

export class VariableTypeConverter implements BodyConverter<VariableType> {
  public encode(
    model: VariableType,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeVariableType(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): VariableType {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readVariableType();
  }
}

export class VariableMetaConverter implements BodyConverter<VariableMeta> {
  public encode(
    model: VariableMeta,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeVariableMeta(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): VariableMeta {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readVariableMeta();
  }
}
